export default {
    page_title: 'Lista widget',

    create_new: 'Creaza un widget nou',

    new: 'Widget Nou',

    update: 'Modifica Widget',

    price: 'Pretul',

    no_items: 'Nu a fost găsit niciun rezultat',

    reduced_price: 'Pretul Redus',

    published: 'Publicat',

    unpublished: 'Nepublicat',

    errors: {

        image_required: 'Imaginea este obligatorie pentru toate randurile',

        slug: 'Id-ul este obligatorie pentru toate randurile',

        config_id_required: 'Id-ul de config este obligatorie pentru toate randurile',

        product_required: 'Produsul este obligatoriu pentru toate randurile',

    },

    form_actions: {

        select_type: 'Selecteaza Tipul',

        select_product: 'Selecteaza Produsul',

        select_image: 'Selecteaza Imaginea',

        select_id: 'Adauga un id',

        select_config_id: 'Adauga Config ID',

        select_id_info: 'E nevoie pentru a fi usor identificat de catre alte surse',

        select_provider: 'Selecteaza Furnizorul',

        add_row: 'Adaugă Produs',

        save: 'Salvează',

        reorder_drag: 'Trage pentru reordonare',

        drag: 'Trage',

        remove: 'Elimină',

        change_product: 'Schimbă produsul',

        copy: 'Copiază'

    },

    reason: {

        inactive_product: 'Produsul a fost dezactivat de catre furnizor',

        invalid_id: 'Produsul a fost sters din Baza de date, sau a fost modificat de catre furnizor',

    },

    table: {

        header: {

            data: 'Data',

            id: 'Id',

            type: 'Tipul',

            published: 'Publicat',

            available_start: 'Valabil din data de',

            available_end: 'Valabil pana la data de',

            created_at: 'Data Crearii',

            updated_at: 'Data Modificarii',

            status: 'Status',

        }

    },

    modal: {

        select_product_title: 'Selecteaza Produsul',

        provider: 'Furnizor',

        select_provider_first: 'Selecteaza Furnizorul',

        name: 'Nume',

        brand: 'Brand',

        price: 'Pret',

        action: 'Actiune',

    },
    carousel: {
        common: {
            active: 'Activ',
            inactive: 'Inactiv',
            product: 'Produs',
            products: 'Produse',
            offer: 'Ofertă',
            offers: 'Oferte',
            benefits: 'Beneficii',
            transparent: 'Transparent',
            languages: {
                ro: 'RO',
                en: 'EN',
            },
            positions: {
                topLeft: 'Stânga sus',
                topRight: 'Dreapta sus',
                bottomLeft: 'Stânga jos',
                bottomRight: 'Dreapta jos',
            }
        },
        generalSettings: {
            title: 'Setări generale',
            sections: {
                statusIdentity: 'Status și identitate',
                availability: 'Disponibilitate',
                widgetBehavior: 'Comportament widget',
            },
            fields: {
                status: 'Status',
                widgetActive: 'Widget activ',
                priority: 'Prioritate',
                productType: 'Tip produse',
                widgetId: 'Widget ID',
                tracking: 'Tracking',
                availableStart: 'Data și ora de început',
                availableEnd: 'Data și ora de sfârșit',
                cardRatio: 'Raport card',
                autoScroll: 'Scroll automat',
                displayPageIndicator: 'Afișează indicatorul de pagină',
            },
            placeholders: {
                widgetId: 'ex: carrefour_100_ron',
                tracking: 'tracking',
            },
            help: {
                productType: 'Nu poți combina benefits cu offers în același widget.',
                widgetId: 'Câmp obligatoriu. Se transformă automat într-un slug folosind underscore.',
                cardRatio: 'Valoarea reprezintă raportul lățime:înălțime. Exemplu: 2 = 2:1',
            }
        },
        generalTab: {
            title: 'Imagine fundal comună',
            description: 'Dacă încarci o imagine aici, ea va fi folosită ca fundal comun pentru toate produsele din widget, acolo unde produsul nu are o imagine proprie configurată.',
            fields: {
                uploadImage: 'Încarcă imagine',
            },
            help: {
                acceptedFormat: 'Format acceptat: imagine. Mărime maximă: 1 MB.',
            },
            actions: {
                removeImage: 'Elimină imaginea',
            },
            errors: {
                invalidImage: 'Fișierul selectat trebuie să fie o imagine.',
                imageTooLarge: 'Imaginea nu trebuie să depășească 1 MB.',
            },
            alt: {
                backgroundPreview: 'Preview imagine fundal',
            }
        },
        textSettings: {
            title: 'Conținut text',
            sections: {
                title: 'Titlu',
                subtitle: 'Subtitlu',
                footer: 'Footer',
            },
            errors: {
                maxLength: 'Ai atins limita maximă de 100 de caractere.',
            }
        },
        tabs: {
            general: 'General',
            text: 'Texte',
            products: 'Produse',
            offers: 'Oferte',
        },
        productsTab: {
            description: 'Fiecare {item} reprezintă un slide din carousel. În interiorul lui poți configura imaginea, stilul cardului și badge-urile afișate peste imagine.',
            warningInactive: 'Widget-ul este inactiv. Activează widget-ul pentru a putea edita {items}.',
            actions: {
                addProduct: 'Adaugă produs',
                addOffer: 'Adaugă ofertă',
            },
            defaults: {
                newProduct: 'Produs nou',
                newOffer: 'Ofertă nouă',
            }
        },
        productsList: {
            empty: 'Nu ai adăugat încă {item}.',
            unnamedItem: '{item} fără nume',
            reason: 'Motiv: {reason}',
            actions: {
                replace: 'Schimbă {item}',
                duplicate: 'Duplică',
                delete: 'Șterge',
            },
            alt: {
                preview: 'Preview',
            }
        },
        productEditor: {
            title: 'Configurare slide',
            unnamedProduct: 'Fără nume produs',
            inactiveWarning: 'Produsul este inactiv. Editarea este blocată până când produsul revine în status activ.',
            emptyBadges: 'Nu există badge-uri pentru această poziție.',
            badgeNumber: 'Badge #{index}',
            sections: {
                productStatus: 'Status produs',
                productImage: 'Imagine produs',
                voucherLink: 'Link voucher',
                badges: 'Badge-uri',
            },
            fields: {
                productActive: 'Produs activ',
                reason: 'Motiv',
                uploadImage: 'Încarcă imagine',
                useAutomaticUrl: 'Folosește URL automat',
                voucherUrl: 'URL voucher',
                contentMode: 'Mod conținut',
                insertVariables: 'Inserează variabile',
                titleRo: 'Titlu RO',
                titleEn: 'Titlu EN',
                titleColor: 'Culoare titlu',
                transparentBackground: 'Fundal transparent',
                backgroundColor: 'Culoare fundal',
                badgeImage: 'Imagine badge',
                cornerRadius: 'Rază colțuri',
                useDShape: 'Folosește formă D',
                paddingTop: 'Padding sus',
                paddingLeft: 'Padding stânga',
                paddingRight: 'Padding dreapta',
                paddingBottom: 'Padding jos',
                marginTop: 'Margine sus',
                marginLeft: 'Margine stânga',
                marginRight: 'Margine dreapta',
                marginBottom: 'Margine jos',
            },
            placeholders: {
                reason: 'Motiv indisponibilitate',
                voucherUrl: 'Introdu URL-ul voucher-ului',
                hexColor: '#FFFFFF',
            },
            help: {
                productImage: 'Imaginea produsului este afișată doar dacă nu există imagine globală.',
                voucherUrl: 'Când opțiunea automată este activă, URL-ul se generează pe baza product_id.',
                uncheckTransparent: 'Debifează „Transparent” pentru a seta o culoare de fundal.',
            },
            actions: {
                removeImage: 'Elimină imaginea',
                addBadge: 'Adaugă badge',
            },
            contentModes: {
                custom: 'Personalizat',
                productVariable: 'Variabilă produs',
                mixed: 'Mixt',
            },
            productVariables: {
                name: 'Nume',
                brandName: 'Nume brand',
                value: 'Valoare',
                productName: 'Nume produs',
                price: 'Preț',
                reducedPrice: 'Preț redus',
                reducedUserDiscount: 'Discount utilizator redus',
                discount: 'Discount',
            },
            errors: {
                invalidImage: 'Fișierul selectat trebuie să fie o imagine.',
                imageTooLarge: 'Imaginea nu trebuie să depășească 1 MB.',
            },
            alt: {
                productImagePreview: 'Preview imagine produs',
                badgePreview: 'Preview badge',
            }
        },
        preview: {
            title: 'Preview',
            unavailableProduct: 'Produs indisponibil',
            noBackground: 'Fără fundal',
            empty: 'Adaugă produse pentru a vedea preview-ul complet.',
            previous: 'Anterior',
            next: 'Următor',
            alt: {
                badge: 'badge',
            }
        }
    }
}